import { keysToCamelFromSnake } from '../utils/caseconverters';

export async function getHoldingsChunk(
    page = 1,
    pageSize = 500,
    countryCode = null,
    htmlPath = null
) {
    const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString(),
    });

    if (countryCode) {
        params.append('country_code', countryCode);
    }

    if (htmlPath) {
        params.append('html_path', htmlPath);
    }

    const url = `/wt/fenix/holdings-chunk/?${params.toString()}`;

    const res = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        cache: 'no-store',
    });

    if (res.status < 200 || res.status >= 300) {
        const error = new Error(
            `Failed to fetch holdings chunk. Status: ${res.status}`
        );
        error.response = res;
        throw error;
    }

    return keysToCamelFromSnake(await res.json());
}
